import Informer from './Informer';

export default Informer;
